import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import { useAuth } from '@/auth'
import { ActivityActions, ActivityTypes, MaterialActivityLog } from '@/composables/useActivityLogs'
import { IS_LANXESS } from '@/config/customers'
import { DataObjectData } from '@coac-gmbh/saifty-main-apis'

export default function useApprovalHistory() {
  const ITEM_NAME_PATH_KEY = 'data.name'

  const { t } = useI18n()
  const auth = useAuth()
  const activityFieldsToShowByAction = [
    {
      action: ActivityActions.Create,
      itemsToShowDifferences: [
        // {
        //   key: 'id',
        //   label: t('ID'),
        //   isFieldToShowDetails: true,
        // },
        {
          key: ITEM_NAME_PATH_KEY,
          label: t('Name'),
          canBeTranslated: true,
          isFieldToShowDetails: true,
        },
        {
          key: 'data.value',
          label: t('Value'),
        },
        {
          key: 'provenance.action',
          label: t('Status'),
        },
      ],
    },
    {
      action: ActivityActions.Update,
      itemsToShowDifferences: [
        // {
        //   key: 'id',
        //   label: t('ID'),
        //   isFieldToShowDetails: true,
        // },
        {
          key: ITEM_NAME_PATH_KEY,
          label: t('Name'),
          canBeTranslated: true,
          isFieldToShowDetails: true,
        },
        {
          key: 'data.value',
          label: t('Value'),
        },
        {
          key: 'provenance.action',
          label: t('Status'),
        },
      ],
    },
    {
      action: ActivityActions.Delete,
      itemsToShowDifferences: [
        {
          key: 'id',
          label: t('ID'),
          isFieldToShowDetails: true,
        },
        {
          key: ITEM_NAME_PATH_KEY,
          label: t('Name'),
          canBeTranslated: true,
          isFieldToShowDetails: true,
        },
      ],
    },
  ]

  function formatActivityLogToStoreInApprovalMetadata(
    action: ActivityActions,
    itemsChanges: { object: DataObjectData; objectChanges?: DataObjectData }[]
  ) {
    const itemsChangesMapped = itemsChanges.map<MaterialActivityLog>((item) => {
      return {
        // TODO: Improve the time format
        time: dayjs().format('MM.DD.YYYY, HH:mm:ss'),
        user: IS_LANXESS
          ? auth.user?.id || auth.user?.nickname || auth.user?.email || 'N/A'
          : auth.user?.nickname || auth.user?.email || 'N/A',
        action,
        type: ActivityTypes.Material,
        object: item.object,
        objectChanges: item.objectChanges ? item.objectChanges : undefined,
      }
    })
    return itemsChangesMapped
  }

  function getActivityFieldsToShowByAction(action: ActivityActions) {
    return activityFieldsToShowByAction.find((a) => a.action === action)
  }

  return {
    ITEM_NAME_PATH_KEY,
    formatActivityLogToStoreInApprovalMetadata,
    getActivityFieldsToShowByAction,
  }
}
